<template>
  <div
    class="question-add smart-input rounded py-1
    flex align-center bg-white"
    v-on="$listeners">
    <button
      v-bind="buttonBind"
      class="question-add__option"
      @click="$emit('click', $event)">
      Adicionar opção
    </button>

    <template v-if="!hasOtherOption">
      <span class="inline-block mr-1 pr-1-2">
        ou
      </span>
      <button
        v-bind="buttonBind"
        class="text-ui-accent question-add__other"
        @click="addOther">
        adicionar outro
      </button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    hasOtherOption: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    buttonBind: {
      class: `question-add__option cursor-pointer
              font-opacity-hg py-1 rounded h-full`
    }
  }),
  methods: {
    addOther(event) {
      this.$emit('addOther', event);
    }
  }
};
</script>

<style lang="scss">
.question-add {
  cursor: text;
  &.smart-input {
    padding-right: 0;
  }
  &__other, &__option {
    border: none;
    transition-property: opacity, background;
    transition-duration: $transition-sm-slow;
    transition-timing-function: $transition-easing-default;
    padding: $spacing-padding-xxsmall;
    &:hover {
      opacity: $font-opacity-md;
    }
    &:focus {
      outline: none;
    }
    &:focus, &:active {
      opacity: 1;
    }
  }
  &__other {
    text-decoration: underline;
    &:focus, &:active {
      background: rgba($color-ui-accent, $opacity-low-min);
    }
  }
  &__option {
    margin-left: - $spacing-margin-xxsmall;
    &:focus, &:active {
      background: rgba($color-ui-black, $opacity-low-min);
    }
  }
}
</style>
